module.exports = __webpack_public_path__ + "img/create-game-icon-colored.ec319b03.svg";